import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { headCellsCitizenshipEditMode } from './constants';
import { useFormikContext } from 'formik';
import { CitizenshipVM } from 'shell/view-models/citizenship';
import CitizenshipForm from 'shell/components/shared/citizenship-form';
import { NewPersonVM } from 'shell/components/shared/sipo-person-form/new-person';

const CitizenshipComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onDelete = useEventCallback((citizen: CitizenshipVM) => {
    const citizens = formContext.values.citizenship?.slice() || [];

    const filteredCitizens = citizens.filter(
      (citizeToFilter) => citizeToFilter.code !== citizen.code
    );

    formContext.setFieldValue('citizenship', filteredCitizens);
  });

  const onAddToTable = useEventCallback((values: Array<CitizenshipVM>) => {
    formContext.setFieldValue('citizenship', values);
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-citizenship-content"
        id="panel-person-citizenship-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>
          Cittadinanza *
          <Typography style={{ color: '#d6012e', display: 'inline', paddingLeft: '5px' }}>
            {formContext.errors.citizenship}
          </Typography>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CitizenshipForm
          headCells={headCellsCitizenshipEditMode}
          isEditMode // fixed
          onAddToTable={onAddToTable}
          citizens={formContext.values.citizenship as Array<CitizenshipVM>}
          onDelete={onDelete}
          dateControl={formContext.values.generality?.birthDate || null}
          numberMaxCitizenship={1}
          // error={Boolean(formContext.errors.citizenship)}
          messaggeError={formContext.errors.citizenship}
        />
      </AccordionDetails>
    </Accordion>
  );
};

CitizenshipComponent.displayName = 'Citizenship component';

const Citizenship = memo(CitizenshipComponent);

export default Citizenship;
